import {Injectable} from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { setting } from '../../../../setting';
import { Observable } from 'rxjs';

@Injectable()

export class SignupService {
	private baseUrl:string;
  private authUrl: string;

	constructor(private _http:HttpClient){
		this.baseUrl = setting.apiBookingUrl;
    this.authUrl = setting.authApiUrl;
	}

	signup(signup: any){
		let json = JSON.stringify(signup);
		let headers = new HttpHeaders();
		headers.append('Content-Type','application/json');
		return this._http.post(this.baseUrl+'joinus', json, {headers: headers});
	}


  categories(): Observable<any> {
    return this._http.get(this.baseUrl+'products/category');
  }

  validateTaxDocument(taxDocumentNumber: string): Observable<any> {
    const payload = { tax_document_number: taxDocumentNumber }
    return this._http.post(this.baseUrl+'contact/validate-tax-document', payload);
  }

}
